import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.FUELS}/fuels`;


async function list() {
  try {
    let response = await api.get(basePath);
    let treated = errorHandling.handleResponse(response, "fuelService.list");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.list");
    return null;
  }
}


async function create(payload) {
  try {
    let response = await api.post(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "fuelService.create");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.create");
    return null;
  }
}


async function getById(fuelTypeId) {
  try {
    let response = await api.get(`${basePath}/${fuelTypeId}`);
    let treated = errorHandling.handleResponse(response, "fuelService.getById");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.getById");
    return null;
  }
}


async function update(fuelTypeId, payload) {
  try {
    let response = await api.put(`${basePath}/${fuelTypeId}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "fuelService.update");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.update");
    return null;
  }
}


async function addRefueling(payload) {
  try {
    let response = await api.post(`${basePath}/refuelings`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "fuelService.addRefueling");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.addRefueling");
    return null;
  }
}


async function deleteRefueling(payload) {
  try {
    let response = await api.delete(`${basePath}/refuelings`, {
      data: JSON.stringify(payload),
    });
    let treated = errorHandling.handleResponse(response, "fuelService.deleteRefueling");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.deleteRefueling");
    return null;
  }
}


async function getRefuelingsByVehicle(vehicleId) {
  try {
    let response = await api.get(`${basePath}/vehicles/${vehicleId}/refuelings`);
    let treated = errorHandling.handleResponse(response, "fuelService.getRefuelingsByVehicle");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.getRefuelingsByVehicle");
    return null;
  }
}

export const fuelService = {
  list,
  create,
  getById,
  update,
  addRefueling,
  deleteRefueling,
  getRefuelingsByVehicle,
};
